"use client"

/**
 * Where a category sits, drawn the same way everywhere.
 *
 * The path above, small and muted, wrapping at its separators so a long one
 * reads as a line of places rather than a clipped string; the category itself
 * below it, in full. Nothing here truncates: a category title can be a hundred
 * characters and the person choosing needs all of it.
 */

import * as React from "react"

import { cn } from "@/lib/utils"

export function CategoryPath({
  trail,
  name,
  className,
  nameClassName,
}: {
  /** The levels above the category, outermost first. */
  trail: readonly string[]
  /** The category itself. Omit to show only the path. */
  name?: string
  className?: string
  nameClassName?: string
}) {
  const levels = trail.filter(Boolean)
  return (
    <span className={cn("flex min-w-0 flex-col gap-0.5", className)}>
      {levels.length > 0 ? (
        <span className="flex min-w-0 flex-wrap items-center gap-x-1 gap-y-0 text-xs leading-snug text-muted-foreground">
          {levels.map((level, index) => (
            <React.Fragment key={`${index}-${level}`}>
              {index > 0 ? (
                <i className="fa-solid fa-chevron-right shrink-0 text-[0.5rem] opacity-60" aria-hidden="true" />
              ) : null}
              <span className="min-w-0 break-words">{level}</span>
            </React.Fragment>
          ))}
        </span>
      ) : null}
      {name ? (
        <span className={cn("min-w-0 break-words text-sm font-semibold leading-snug text-foreground", nameClassName)}>
          {name}
        </span>
      ) : null}
    </span>
  )
}
